import React from "react"
import styles from "./styles.scss"
import cx from "classnames"

class TextSection extends React.Component {
  render() {
    const { variant } = this.props

    return (
      <section
        className={cx(styles.container, {
          [styles.dark]: variant === "dark",
          [styles.gray]: variant === "gray",
        })}
      >
        {this.props.children}
      </section>
    )
  }
}

export default TextSection



// WEBPACK FOOTER //
// ./src/components/CaseStudy/TextSection/index.jsx